import { APP_NAME } from "../config";

export const tutorialModules = [
  {
    id: 1,
    title: `Instalação do ${APP_NAME}`,
    videos: [
      {
        id: 8,
        title: `Como baixar o ${APP_NAME} no Windows`,
        duration: "1:53",
        url: "https://youtu.be/qOBIYYLWOD4",
      },
      {
        id: 3,
        title: `Executando o ${APP_NAME} no Mac`,
        duration: "1:56",
        url: "https://youtu.be/JOgzcQh76kU",
      },
    ],
  },
  {
    id: 2,
    title: `Configuração e Uso do ${APP_NAME}`,
    videos: [
      {
        id: 1,
        title: `Usando o ${APP_NAME} com o Gemini`,
        duration: "4:52",
        url: "https://youtu.be/ASO8qvvz9Pw",
      },
      {
        id: 2,
        title: `Usando o ${APP_NAME} com o GPT`,
        duration: "7:25",
        url: "https://youtu.be/0owgiWkgXwI",
      },
      {
        id: 9,
        title: `Como criar prompts para o ${APP_NAME}`,
        duration: "11:41",
        url: "https://youtu.be/sqFk2kt6aVQ",
      },
      {
        id: 6,
        title: "Configurações de conversas",
        duration: "4:36",
        url: "https://youtu.be/8FqOeHvb-Sk",
      },
      {
        id: 10,
        title: `Como criar uma nova instância de conexão dentro do ${APP_NAME}`,
        duration: "0:34",
        url: "https://youtu.be/JuaHfY0FYec",
      },
      {
        id: 7,
        title: "Como importar informações de outra instância",
        duration: "0:25",
        url: "https://youtu.be/VO_SR94OwnY",
      },
      {
        id: 11,
        title: "Como usar o Google Calendar",
        duration: "N/A",
        url: "https://youtu.be/nPzu-Md0IBk?si=LLhRv_SSUWkcKb8h",
      },
      {
        id: 12,
        title: "Alerta de atendimento humano",
        duration: "N/A",
        url: "https://youtu.be/Nz4HIcWknbo?si=55B5UhsywdH86QmE",
      },
    ],
  },
  {
    id: 3,
    title: `Hospedando o ${APP_NAME} em uma VPS`,
    videos: [
      {
        id: 5,
        title: `Como hospedar o ${APP_NAME} no Database Mart`,
        duration: "8:21",
        url: "https://youtu.be/Mti6aWyzW9g",
      },
      {
        id: 4,
        title: `Alternativa: Como subir o ${APP_NAME} na AWS Lightsail`,
        duration: "2:38",
        url: "https://youtu.be/hnXzWqoMZBs",
      },
    ],
  },
];

export const extractYoutubeId = (url) => {
  if (url.includes("youtu.be/")) {
    const id = url.split("youtu.be/")[1].split("?")[0];
    return id;
  }
  if (url.includes("v=")) {
    const id = url.split("v=")[1].split("&")[0];
    return id;
  }
  return "";
};
